import styled from "styled-components";

//Interfaces
import { CircleColorPropsInterface, AddEstablishmentHeaderPageInterface, RadioButtonInterface } from "./interfaces";

//Assets
import colors from "../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

export const MainColumn = styled.div`
    width: 75%;
    padding-right: 35px;

    @media (max-width: 768px){
        width: 100%;
        padding-right: 0px;
    }
`;

export const SideColumn = styled.div`
    display: flex;
    justify-content: center;
    width: 25%;
    margin-top: 25px;

    @media (max-width: 768px){
        display: none;
    }
`;

export const EstablishmentInfoMainContainer = styled.div`
    display: none;

    @media (max-width: 768px){
        width: 100%;
        display: flex;
        justify-content: center;
    }
`;

export const EstablimentBoxAndGraficContainer = styled.div`
    display: flex;
    justify-content: space-between;

    @media (min-width: 1400px) {
        width: max(726px, 49%);
    }
    
    .carousel-indicators {
        bottom: -40px;

        li {
            background-color: #F58B1E;
        }
    }

    @media (max-width: 1200px) {
        display: block;
    }
`;

export const THead = styled.thead`
  background: ${colors.grayLight} 0% 0% no-repeat padding-box;
  height: 34px;
  opacity: 1;
`;

export const Th = styled.th`
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: ${colors.grayDark};
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const ThFilterable = styled.th`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: ${colors.grayDark};
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`

export const Td = styled.td`
  font-family: muli, sans-serif;
  font-weight: 300;
  font-size: normal;
  color: ${colors.blackLight};
  text-align: center;
  vertical-align: middle !important;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const CircleStatus = styled.div`
    width: 8px;
    height: 8px;
    margin-right: 3px;
    border-radius: 4px;
    margin-top: 2px;
    background-color: ${(p: CircleColorPropsInterface) => p.color};
`;

export const DetailsButton = styled.div`
    width: 72px;
    height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: none;
    background: transparent 0% 0% no-repeat padding-box;
    border: 1px solid ${colors.primary};
    border-radius: 4px;
    color: ${colors.primary};
    font: normal normal 600 8px Muli;
    cursor: pointer;

    &:hover{
        background-color: ${colors.primary};
        color: ${colors.white};
    }

    &:focus{
        outline: 0;
    }
`;

export const EstablishmentInfoContainer = styled.div`
    width: 233px;

    @media (max-width: 768px) {
        width: 400px;
    }

    @media (max-width: 500px) {
        width: 100%;
    }
`;

export const NavigationContainer = styled.ul`
    height: 36px;
    margin-top: 69px;
`;

export const TextContainer = styled.div`
    width: max-content;
`;

export const InfoContainer = styled.div`
    border-bottom: 1px solid #B8B4CC;
    margin-bottom: 24px;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    @media (max-width: 500px){
        display: block;
    }
`;

export const FirstColumn = styled.div`
    width: 40%;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 15px;
    }
`;

export const SecondColumn = styled.div`
    width: 35%;
    
    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 15px;
    }
`;

export const ThirdColumn = styled.div`
    width: 25%;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 15px;
    }
`;

export const Title = styled.h2`
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: #454546;
    margin-bottom: 4px;
    line-height: 1;
`;

export const Info = styled.p`
    margin-bottom: 0px;
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: #B8B4CC;
`;

export const TitleField = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    margin-bottom: 24px;
    color: #454546;
`;

export const ColumnPrimaryData = styled.div`
    margin-right: 77px;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 15px;
        margin-right: 0px;
    }
`;

export const ColumnAddress = styled.div`
    margin-right: 85px;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 15px;
        margin-right: 0px;
    }
`;

export const ColumnAddressNumber = styled.div`
    width: 22%;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 15px;
    }
`;

export const ShowDetails = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 14px;
    margin-left: 17px;
    font: normal normal 600 10px Muli;
    letter-spacing: 0.5px;
    color: #F58B1E;
    cursor: pointer;
`;

export const AddEstablishmentHeader = styled.ul`
    display: flex;
    align-items: center;
    margin-bottom: 34px;
    height: 50px;
    list-style: none;
    padding: 0;

    & li:first-child:after {
        width: 0;
    }
`;

export const AddEstablishmentHeaderPage = styled.li`
    font: normal normal 600 16px Muli;
    color: ${(p: AddEstablishmentHeaderPageInterface) => p.isActualOrPrevius ? colors.primary : colors.grayDark } ;
    margin-bottom: 0px;
    line-height: 1;
    cursor: pointer;
    width: 25%;
    position: relative;
    text-align: center;

    &::before {
        display: flex;
        align-items: center;
        justify-content: center;
        content: attr(data-step);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: ${(p: AddEstablishmentHeaderPageInterface) => p.isActualOrPrevius ? colors.primary : colors.grayLight } ;
        color: ${(p: AddEstablishmentHeaderPageInterface) => p.isActualOrPrevius ? colors.white : colors.grayDark } ;
        position: absolute;
        top: -50px;
        left: calc(50% - 20px);
        z-index: 30;
    }

    &::after {
        content: "";
        width: 100%;
        height: 5px;
        background: ${(p: AddEstablishmentHeaderPageInterface) => p.isActualOrPrevius ? colors.primary : colors.grayLight } ;
        position: absolute;
        top: -35px;
        left: -50%;
    }

    @media (max-width: 576px) {
        margin-bottom: 5px;
        font-size: 12px;
    }
`;

export const DashedBetweenPages = styled.div`
    width: 95px;
    display: flex;
    justify-content: center;
    margin-left: 10px;
    margin-right: 10px;
    color: ${(p: AddEstablishmentHeaderPageInterface) => p.isActualOrPrevius ? colors.primary : "#707070"} ;
    letter-spacing: 3px;

    @media (max-width: 500px) {
        display: none;
    }
`;

export const RowForInput = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 43px;
    align-items: end;

    @media (max-width: 500px){
        display: block;
        margin-bottom: 0px;
    }
`;

export const RowForTwoInput = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (max-width: 500px){
        display: block;
    }
`;

export const FieldLabel = styled.label`
    font-size: 14px;
    display: flex;
`

export const InputContainer = styled.div`
    width: 47%;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 30px;
    }
`;

export const InputDetail = styled.p`
    width: 100%;
    text-align: right;
    font: normal normal 300 9px Muli;
    color: #B8B4CC;
    margin-top: 7px;
    margin-bottom: 0px;
`;

export const ColumnForTwoInputs = styled.div`
    width: 47%;

    @media (max-width: 500px){
        width: 100%;
    }
`;

export const RowForButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 35px;
`;

export const ButtonContainer = styled.div`
    width: 47%;

    @media (max-width: 500px){
        width: 100%;
    }
`;

export const InputWithHintContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const Select = styled.select`
    width:100%;
    height: 31px;
    margin-bottom: 23px;
    background: ${colors.white};
    color: ${colors.tertiary};
    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    outline: none;
    padding: 0.4em 1em 0.4em;
    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;

    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:focus {
        color: var(--gray);
        border: 1px solid ${colors.secondaryDark};
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:disabled {
        background-color: ${colors.grayLightest};
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers */
        text-transform: none;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        text-transform: none;
    }
    &::placeholder {
        /* Recent browsers */
        text-transform: none;
    }
`;

export const RowForRadioButton = styled.div`
    display: flex;
    margin-bottom: 34px;
`;

export const FormRadioButtonContainer = styled.div`
    display: flex;
    align-items: flex-start;
    height: 13px;
    font: normal normal 300 10px/13px Muli;
    color: ${colors.gray};
    margin-right: 25px;
`;

export const FormRadioButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10px;
    height: 10px;
    border: 1px solid ${colors.primary};
    border-radius: 5px;
    margin-right: 10px;
`;

export const FormRadioButtonContent = styled.div`
    width: 6px;
    height: 6px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? colors.primary : "transparent"};
    border-radius: 5px;
`;

export const ErrorMessage = styled.span`
  font-size: 16px;
  color: red;
`;

export const RadioButtonRow = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
    margin-bottom: 28px;
`;

export const RadioButtonForm = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const RadioButtonContainer = styled.div`
    display: flex;
    width: 10px;
    height: 10px;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.primary};
    border-radius: 9px;
    margin-right: 8px;
`;

export const RadioButtonContent = styled.div`
    width: 6px;
    height: 6px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? colors.primary : "transparent"};
`;

export const RadioButtonDescription = styled.span`
    font: normal normal 300 13px Muli;
    color: #707070;
`;

export const ContainerDropzone = styled.div`
    width: 45%;

    @media (max-width: 500px) {
        width: 100%;
        margin-bottom: 35px;
    }
`

export const ModalContinue = styled.div`
    background: white;
    position: absolute;
    z-index: 50;
    border-radius: 10px;
    box-shadow: 0 0 10px 2px gray;
    transform: translate(0px, -32px);
    display: ${props => props.datatype === "0" ? "block" : "none"};

    @media(max-width: 780) {
        transform: translate(0%, -15%);
    }
`

export const HeaderModalDialog = styled.div`
    /* padding: 10px; */
`

export const BodyModalDialog = styled.div`
    padding: 10px;
`

export const FooterModalDialog = styled.div`
    padding: 10px 10px 35px 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    #cancel {
        box-shadow: none;
        width: 150px;
        background: ${colors.grayDark}
    }

    #continue {
        width: 150px;
    }
`